import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../src/store/useAuthStore";
import { useEffect } from "react";

const ALWAYS_STAY_ROUTES = [
  '/set-password'
]

const PUBLIC_ROUTES = [
  '/login',
]

const AuthLayout = () => {
  const { accessToken, refreshToken } = useAuthStore();
  const nav = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip auth checks in development mode
    if (import.meta.env.MODE === 'development') {
      return;
    }

    if (!ALWAYS_STAY_ROUTES.includes(pathname)) {
      if (accessToken && PUBLIC_ROUTES.includes(pathname)) {
        nav('/');
        return;
      }
      if (!accessToken && !PUBLIC_ROUTES.includes(pathname)) {
        nav('/login');
        return;
      }
    }
  }, [accessToken, pathname, nav])

  return <Outlet />;
};

export default AuthLayout